// extracted by mini-css-extract-plugin
export var askAiIcon = "_ly-j";
export var category = "_ly-9";
export var categoryHeader = "_ly-e";
export var container = "_ly-0";
export var group = "_ly-a";
export var groupItems = "_ly-f";
export var groupSeparator = "_ly-k";
export var loading = "_ly-1";
export var noResults = "_ly-3";
export var placeholder = "_ly-2";
export var resultContent = "_ly-5";
export var resultIcon = "_ly-c";
export var resultItem = "_ly-g";
export var resultMeta = "_ly-8";
export var resultSubtitle = "_ly-7";
export var resultSuffix = "_ly-i";
export var resultTitle = "_ly-6";
export var resultsList = "_ly-4";
export var searchGroup = "_ly-d";
export var selected = "_ly-h";
export var subgroup = "_ly-b";